document.addEventListener('DOMContentLoaded', () => {
  const productFormComponent = document.querySelector('product-form-component');
  const form = document.querySelector('form[data-type="add-to-cart-form"]');

  if (!productFormComponent || !form) return;

  const addButton =
    form.querySelector('button[name="add"]') ||
    form.querySelector('.add-to-cart-button') ||
    document.querySelector('button[name="add"]');

  const addToCartComponent = form.querySelector('add-to-cart-component');

  if (addButton) {
    addButton.dataset.puppet = 'true';
  }

  const checkboxPersonalizado = document.querySelector('input[id^="addon-personalizado-"]');
  const checkboxParches = document.querySelector('input[id^="addon-parches-"]');

  const textInput = document.querySelector(
    'product-custom-property-component input[type="text"], product-custom-property-component textarea'
  );

  const addonOptions = document.querySelector('.product-addon-options');

  if (!textInput && addonOptions) {
    addonOptions.style.display = 'none';
    return;
  }

  if (textInput?.name) {
    textInput.dataset.originalName = textInput.name;
    textInput.removeAttribute('name');
  }

  let isSubmitting = false;

  const blockNativeSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }
  };

  const clearSuccessAnimations = () => {
    const runClear = () => {
      if (addButton) {
        addButton.removeAttribute('data-added');
        addButton.dataset.added = 'false';
        addButton.classList.remove('added', 'is-added', 'success', 'is-success');
      }

      document.querySelectorAll('fly-to-cart').forEach((el) => el.remove());
    };

    runClear();
    requestAnimationFrame(runClear);
    setTimeout(runClear, 50);
    setTimeout(runClear, 200);
    setTimeout(runClear, 500);
  };

  const resetAddButtonState = () => {
    if (!addButton) return;

    addButton.disabled = false;
    addButton.removeAttribute('aria-busy');
    addButton.classList.remove('loading', 'is-loading', 'pending');

    const productFormButtons = form.querySelector('[ref="productFormButtons"]');
    if (productFormButtons) {
      productFormButtons.classList.remove('loading', 'is-loading', 'pending');
    }

    const productFormComponentEl = document.querySelector('product-form-component');
    if (productFormComponentEl) {
      productFormComponentEl.classList.remove('loading', 'is-loading', 'pending');
      productFormComponentEl.removeAttribute('aria-busy');
    }

    clearSuccessAnimations();
  };

  const triggerFlyToCartAnimation = () => {
    if (!addButton || !addToCartComponent) return;

    const cartIcon = document.querySelector('.header-actions__cart-icon');
    const image = addToCartComponent.dataset.productVariantMedia;

    if (!cartIcon || !image) return;

    const flyToCartElement = document.createElement('fly-to-cart');
    const flyToCartClass = addButton.classList.contains('quick-add__button')
      ? 'fly-to-cart--quick'
      : 'fly-to-cart--main';

    flyToCartElement.classList.add(flyToCartClass);
    flyToCartElement.style.setProperty('background-image', `url(${image})`);
    flyToCartElement.style.setProperty('--start-opacity', '0');
    flyToCartElement.source = addButton;
    flyToCartElement.destination = cartIcon;

    document.body.appendChild(flyToCartElement);
  };

  const triggerSuccessAnimations = async () => {
    try {
      if (typeof addToCartComponent?.animateAddToCart === 'function') {
        await addToCartComponent.animateAddToCart();
      }
    } catch (error) {
      console.error('Error al animar botón de add to cart:', error);
    }

    try {
      triggerFlyToCartAnimation();
    } catch (error) {
      console.error('Error al animar fly-to-cart:', error);
    }
  };

  const errorContainer = form.querySelector('[ref="addToCartTextError"]');

  const showFormError = (message) => {
    if (!errorContainer) {
      alert(message);
      return;
    }

    let messageNode = errorContainer.querySelector('.product-form-text__error-message');

    if (!messageNode) {
      messageNode = document.createElement('span');
      messageNode.className = 'product-form-text__error-message';
      errorContainer.appendChild(messageNode);
    }

    messageNode.textContent = message;
    errorContainer.classList.remove('hidden');
  };

  const clearFormError = () => {
    if (!errorContainer) return;

    const messageNode = errorContainer.querySelector('.product-form-text__error-message');
    if (messageNode) {
      messageNode.textContent = '';
    }

    errorContainer.classList.add('hidden');
  };

  const getFriendlyCartErrorMessage = (errorData) => {
    const rawMessage =
      errorData?.description ||
      errorData?.message ||
      '';

    const normalized = String(rawMessage).toLowerCase();

    if (
      normalized.includes('only') ||
      normalized.includes('available') ||
      normalized.includes('stock') ||
      normalized.includes('inventory') ||
      normalized.includes('agotad') ||
      normalized.includes('disponible')
    ) {
      return 'No hay suficiente inventario disponible para la cantidad seleccionada. Reduce la cantidad e inténtalo de nuevo.';
    }

    return rawMessage || 'No se pudo agregar el producto al carrito. Intenta de nuevo.';
  };

  const isPartialInventoryError = (errorData) => {
    const rawMessage =
      errorData?.description ||
      errorData?.message ||
      '';

    const normalized = String(rawMessage).toLowerCase();

    return (
      normalized.includes('due to availability') ||
      normalized.includes('solo se añadió') ||
      normalized.includes('solo se agreg') ||
      (normalized.includes('only') && normalized.includes('added')) ||
      (normalized.includes('available') && normalized.includes('added'))
    );
  };

  const getCart = async () => {
    const response = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('No se pudo consultar el carrito.');
    }

    return response.json();
  };

  const dispatchCartUpdate = async (variantId) => {
    const cart = await getCart();

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'product-addons',
          data: {
            source: 'product-addons',
            productId: String(variantId),
            variantId: String(variantId),
            itemCount: cart.item_count
          }
        }
      })
    );
  };

  const normalizeProperties = (properties = {}) => {
    const normalized = {};
    Object.entries(properties || {}).forEach(([key, value]) => {
      normalized[String(key)] = String(value ?? '');
    });
    return normalized;
  };

  const arePropertiesEqual = (a = {}, b = {}) => {
    const normA = normalizeProperties(a);
    const normB = normalizeProperties(b);

    const keysA = Object.keys(normA).sort();
    const keysB = Object.keys(normB).sort();

    if (keysA.length !== keysB.length) return false;

    return keysA.every((key, index) => {
      return key === keysB[index] && normA[key] === normB[key];
    });
  };

  const buildAttemptedDescriptors = (items) => {
    return items.map((item) => ({
      id: Number(item.id),
      properties: normalizeProperties(item.properties || {})
    }));
  };

  const getMatchingLineItems = (cart, descriptor) => {
    return (cart.items || []).filter((item) => {
      return (
        Number(item.variant_id) === Number(descriptor.id) &&
        arePropertiesEqual(item.properties || {}, descriptor.properties || {})
      );
    });
  };

  const snapshotAttemptedQuantities = (cart, attemptedDescriptors) => {
    return attemptedDescriptors.map((descriptor) => {
      const matchingItems = getMatchingLineItems(cart, descriptor);
      const quantity = matchingItems.reduce((sum, item) => sum + Number(item.quantity || 0), 0);

      return {
        descriptor,
        quantity
      };
    });
  };

  const setCartLineQuantity = async (key, quantity) => {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity
      })
    });

    if (!response.ok) {
      throw new Error('No se pudo revertir una línea del carrito.');
    }
  };

  const revertPartialAdditions = async (beforeSnapshot) => {
    const currentCart = await getCart();

    for (const entry of beforeSnapshot) {
      const { descriptor, quantity: previousQuantity } = entry;
      const matchingLines = getMatchingLineItems(currentCart, descriptor);

      let currentQuantity = matchingLines.reduce((sum, item) => sum + Number(item.quantity || 0), 0);

      if (currentQuantity <= previousQuantity) continue;

      let quantityToRemove = currentQuantity - previousQuantity;

      for (const line of matchingLines) {
        if (quantityToRemove <= 0) break;

        const lineQty = Number(line.quantity || 0);
        const newQty = Math.max(0, lineQty - quantityToRemove);
        const removed = lineQty - newQty;

        await setCartLineQuantity(line.key, newQty);
        quantityToRemove -= removed;
      }
    }
  };

  const handleCustomAddToCart = async (e) => {
    blockNativeSubmit(e);

    if (isSubmitting) return;
    isSubmitting = true;

    clearFormError();

    if (addButton) {
      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');
    }

    try {
      const variantIdInput = form.querySelector('input[name="id"]');
      const quantityInput = form.querySelector('input[name="quantity"]');

      const variantId = Number(variantIdInput?.value);
      const quantity = parseInt(quantityInput?.value || '1', 10);
      const text = textInput?.value?.trim() || '';

      if (!variantId) {
        resetAddButtonState();
        showFormError('No se encontró la variante del producto.');
        return;
      }

      if (!Number.isFinite(quantity) || quantity < 1) {
        resetAddButtonState();
        showFormError('Selecciona una cantidad válida.');
        return;
      }

      const productTitle =
        document.querySelector('#ProductInformation-' + productFormComponent.dataset.sectionId + ' .view-product-title a')
          ?.textContent?.trim() ||
        document.querySelector('h1')?.textContent?.trim() ||
        '';

      const selectedVariantTitle =
        Array.from(document.querySelectorAll('variant-picker fieldset'))
          .map((fieldset) => {
            const legend = fieldset.querySelector('legend')?.textContent?.trim();
            const selectedInput = fieldset.querySelector('input[type="radio"][data-current-checked="true"]');
            const selectedOption = fieldset.querySelector('select option:checked');
            const selectedValue =
              selectedInput?.value?.trim() ||
              selectedOption?.value?.trim() ||
              selectedOption?.textContent?.trim() ||
              '';

            if (!legend || !selectedValue) return null;
            return `${legend}: ${selectedValue}`;
          })
          .filter(Boolean)
          .join(' | ') || '';

      const baseContextProperties = {
        Jersey: productTitle || 'Jersey',
        Variante: selectedVariantTitle || 'No especificada'
      };

      const items = [
        {
          id: variantId,
          quantity
        }
      ];

      if (checkboxPersonalizado?.checked) {
        if (!text) {
          resetAddButtonState();
          showFormError('Escribe el nombre y número para el dorsal.');
          return;
        }

        items.push({
          id: 48289901052153,
          quantity,
          properties: {
            ...baseContextProperties,
            Dorsal: text
          }
        });
      }

      if (checkboxParches?.checked) {
        items.push({
          id: 48289909047545,
          quantity,
          properties: {
            ...baseContextProperties
          }
        });
      }

      const attemptedDescriptors = buildAttemptedDescriptors(items);
      const cartBeforeAdd = await getCart();
      const beforeSnapshot = snapshotAttemptedQuantities(cartBeforeAdd, attemptedDescriptors);

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        console.error('Error /cart/add.js:', errorData || response.statusText);

        if (isPartialInventoryError(errorData)) {
          try {
            await revertPartialAdditions(beforeSnapshot);
            await dispatchCartUpdate(variantId);
          } catch (revertError) {
            console.error('Error al revertir agregado parcial:', revertError);
          }

          resetAddButtonState();
          showFormError('No hay suficiente inventario disponible para la cantidad seleccionada. Reduce la cantidad e inténtalo de nuevo.');
          return;
        }

        resetAddButtonState();
        showFormError(getFriendlyCartErrorMessage(errorData));
        return;
      }

      await dispatchCartUpdate(variantId);
      await triggerSuccessAnimations();
    } catch (err) {
      console.error('Error al agregar addons:', err);
      resetAddButtonState();
      showFormError('Ocurrió un problema al agregar el producto al carrito. Intenta de nuevo.');
    } finally {
      isSubmitting = false;

      if (addButton) {
        addButton.disabled = false;
        addButton.removeAttribute('aria-busy');
      }
    }
  };

  form.addEventListener('submit', blockNativeSubmit, true);

  if (addButton) {
    addButton.addEventListener('click', handleCustomAddToCart, true);
  }
});